export var CircularStepLoaderSteps;
(function (CircularStepLoaderSteps) {
    CircularStepLoaderSteps[CircularStepLoaderSteps["ONE"] = 1] = "ONE";
    CircularStepLoaderSteps[CircularStepLoaderSteps["TWO"] = 2] = "TWO";
    CircularStepLoaderSteps[CircularStepLoaderSteps["THREE"] = 3] = "THREE";
})(CircularStepLoaderSteps || (CircularStepLoaderSteps = {}));
export var CircularLoaderSize;
(function (CircularLoaderSize) {
    CircularLoaderSize["SMALL"] = "SMALL";
    CircularLoaderSize["NORMAL"] = "NORMAL";
})(CircularLoaderSize || (CircularLoaderSize = {}));
export const svgPaths = [
    'M54.51 15.02a38 38 0 0 1 32.2 55.51l-8.43-4.38a28.5 28.5 0 0 0-24.14-41.63l.37-9.5Z',
    'M85.13 73.3a38 38 0 0 1-64.17.12l8-5.1a28.5 28.5 0 0 0 48.13-.1l8.03 5.07Z',
    'M19.36 70.67a38 38 0 0 1 31.97-55.64l.42 9.5a28.5 28.5 0 0 0-23.98 41.72l-8.41 4.42Z',
];
export const loaderDimensions = {
    [CircularLoaderSize.SMALL]: {
        height: '30',
        width: '30',
    },
    [CircularLoaderSize.NORMAL]: {
        height: '76',
        width: '76',
    },
};
export const getLoaderSvgSize = (loaderSize) => {
    if (loaderSize) {
        return {
            height: loaderDimensions[loaderSize].height,
            width: loaderDimensions[loaderSize].width,
        };
    }
    return {
        height: loaderDimensions[CircularLoaderSize.NORMAL].height,
        width: loaderDimensions[CircularLoaderSize.NORMAL].width,
    };
};
//# sourceMappingURL=circular-step-loader.constants.js.map